export * from "-!../../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=bbc0b1d0&"


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/index.vue?vue&type=template&id=bbc0b1d0&
// module id = 257
// module chunks = 30